import { BODY_SCAN_SEARCH_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

export const getBodyScans = ({ dealerId, vin, registration }, meta = {}) => ({
  type: types.SEARCH_BODY_SCANS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: BODY_SCAN_SEARCH_URL,
      params: { dealerId, vin, registration },
    },
  },
  meta
});

export const openImportBodyScans = (meta = {}) => ({
  type: types.OPEN_BODY_SCANS_IMPORT_MODAL,
  meta,
});

export const closeImportBodyScans = (meta = {}) => ({
  type: types.CLOSE_BODY_SCANS_IMPORT_MODAL,
  meta,
});
